import Vue from 'vue';
import * as BaseComponents from 'components/base';

Object.entries(BaseComponents)
	.forEach(([name, component]) => Vue.component(name, component));
